import React from 'react';
import _ from 'lodash';
import { Divider, Card, Grid, Button, List } from 'semantic-ui-react';

import PathView from '../../PathView';
import Content from '../../Content';
import TaskContainer from '../../TaskContainer';
import EmailInput from '../../EmailInput';
import ClaimSummary from '../../ClaimSummary';
import mapConnection from '../../../utils/connectionMapper';
import FixedIcon from '../../FixedIcon';

const TaskView = ({
  claim,
  task: { id, createdAt, priority, claimId },
  taskTitle,
  loading,
  onClaimClosed,
  paxReplyEmail,
  onInputChange,
  children,
  onMessageSend
}) => {
  const claimPassengers =
    claim && claim.claimsPassengerTicketConnection
      ? mapConnection(claim.claimsPassengerTicketConnection)
      : [];
  const passengerEmail = _.get(claim, 'passengerTicket.passengerEmail', '');
  return (
    <Content fullWidth>
      <PathView
        paths={[
          { name: 'Tasks', path: '/tasks' },
          { name: id, path: `/task/${id}` }
        ]}
      />
      <TaskContainer
        title={taskTitle}
        date={createdAt}
        id={id}
        priority={priority}
        icon='hashtag'
        claimId={claimId}
        loading={loading}
        hideClaim={false}
        onClaimClosed={onClaimClosed}
      >
        <Card.Description>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <ClaimSummary claim={claim} />
                <Divider hidden />
                {claimPassengers.map(claimPassenger => {
                  const { passengerTicket, loa, id } = claimPassenger;
                  return (
                    <List key={id}>
                      <List.Item>
                        <FixedIcon name='attach' />
                        <List.Content>
                          {passengerTicket &&
                            passengerTicket.passengerFirstName}{' '}
                          {passengerTicket &&
                            passengerTicket.passengerLastName}{' '}
                          {loa ? (
                            <a href={loa.myclaimUrl} target='_blank'>
                              LOA preview
                            </a>
                          ) : (
                            '-'
                          )}
                        </List.Content>
                      </List.Item>
                    </List>
                  );
                })}
              </Grid.Column>
              <Grid.Column width={11}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={12}>
                      <EmailInput
                        recipientIconName='user'
                        recipient={passengerEmail}
                        recipientEditable={false}
                        subject='Airrefund - LOA'
                        body={paxReplyEmail}
                        onChange={onInputChange}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        floated='right'
                        primary
                        onClick={onMessageSend}
                        content='Send'
                      />
                      {children}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Description>
      </TaskContainer>
    </Content>
  );
};
export default TaskView;



// WEBPACK FOOTER //
// ./src/component/tasks/SendLoaTask/TaskView.js